import {CustomerVM} from "./CustomerVM.model";

export class CompanyCustomerVM {
  id:number;
  createDate:any;
  status:any;
  companyId:number;
  customerId:number;
  customer:CustomerVM;
  customerIntakeData:any;
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/CompanyCustomerVM.model.ts